import { createAsyncThunk } from '@reduxjs/toolkit';
import authApi from '~/apis/auth';
import { FORGOT_PASSWORD, LOGIN, RESET_PASSWORD } from '~/utils/constants/actionType';
import { IForgotPasswordPayload, IForgotPasswordResponse, ILoginPayload, IResetPasswordPayload, IResetPasswordResponse, IResponseLogin } from '~/utils/interface/auth';

export const handleLogin = createAsyncThunk<IResponseLogin, ILoginPayload>(
  LOGIN,
  async (data: ILoginPayload, { rejectWithValue }) => {
    try {
      const res = await authApi.login(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleForgotPassword = createAsyncThunk<IForgotPasswordResponse, IForgotPasswordPayload>(
  FORGOT_PASSWORD,
  async (data: IForgotPasswordPayload, { rejectWithValue }) => {
    try {
      const res = await authApi.forgotPassword(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleResetPassword = createAsyncThunk<IResetPasswordResponse, IResetPasswordPayload>(
  RESET_PASSWORD,
  async (data: IResetPasswordPayload, { rejectWithValue }) => {
    try {
      const res = await authApi.resetPassword(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
